<div class="block" [formGroup]="formGroup">
  <div class="title" [innerHTML]="field.titleBlock"></div>
  <div class="options">
    <div class="option" *ngFor="let option of options">
      <input type="checkbox" id="{{option.id}}" [value]="option.id" [checked]="isSelected(option)" (change)="onChange($event, option)" />
      <label for="{{option.id}}">{{option.caption || option.title || option.name}} {{option?.subtitle ? ' - ' + option.subtitle : ''}}</label>
    </div>
  </div>
</div>
